// extracted by mini-css-extract-plugin
module.exports = {"cancellationCheckBox":"ToggleButton_cancellationCheckBox__3aro5","toggleLabel":"ToggleButton_toggleLabel__1kvq8","toggleButtonText":"ToggleButton_toggleButtonText__e_Yuo"};